import React from 'react';
import { MetricTooltip } from './MetricTooltip';

interface MetricCardProps {
  title: string;
  value: string;
  performance: {
    level: string;
    color: string;
    icon: React.ReactNode;
  };
  description: string;
}

export function MetricCard({ title, value, performance, description }: MetricCardProps) {
  return (
    <div className="bg-[#f5f5f5] p-4 rounded-lg shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-1">
          <span className="text-sm text-gray-600">{title}</span>
          <MetricTooltip description={description} />
        </div>
        {performance.icon}
      </div>
      <div className="text-2xl font-bold mb-2">{value}</div>
      <span className={`text-xs px-2 py-1 rounded-full ${performance.color} bg-white/80`}>
        {performance.level}
      </span>
    </div>
  );
}